"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.professionRoutes = void 0;
const professionActions_openapi_1 = require("./professionActions.openapi");
exports.professionRoutes = [
    {
        name: 'profession.list',
        path: ['/', '/q/:q'],
        method: 'GET',
        plugins: {
            openapi: professionActions_openapi_1.professionOpenApiDocs['profession.list']
        }
    },
    {
        name: 'profession.create',
        path: ['/'],
        method: 'POST',
        plugins: {
            openapi: professionActions_openapi_1.professionOpenApiDocs['profession.create']
        }
    },
    {
        name: 'profession.get',
        path: '/:id',
        method: 'GET',
        plugins: {
            openapi: professionActions_openapi_1.professionOpenApiDocs['profession.get']
        }
    },
    {
        name: 'profession.update',
        path: '/:id',
        method: 'PUT',
        plugins: {
            openapi: professionActions_openapi_1.professionOpenApiDocs['profession.update']
        }
    },
    {
        name: 'profession.delete',
        path: '/:id',
        method: 'DELETE',
        plugins: {
            openapi: professionActions_openapi_1.professionOpenApiDocs['profession.delete']
        }
    }
];
